export const phoneRegex = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/
export const loginRegex = /^7\d{10}$/
export const pwdRegex = /^[a-zA-Z\d]{6,}$/